/** @format */
import { Block, PageData } from '../config/types';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
interface GetPageDataPartArgs {
    /**
     * The data to search
     */
    data: PageData;

    /**
     * The section that the data should be searched for in
     */
    siteSection: string;

    /**
     * The typename of the content searching for
     */
    typename: string;
}

/**
 * Searches the PageData for a specific block of content
 */
export function getPageDataPart<T extends Block>({
    data,
    siteSection,
    typename,
}: GetPageDataPartArgs): T | undefined {
    if (!Object.keys(data).includes(siteSection)) {
        return undefined;
    }

    const part = data[siteSection].find(
        (item) => item.__typename === typename
    ) as T | undefined;

    return part;
}
